<template>
	<div class="module_page page_content institution" aria-label="Institution Packages view content page">

    	<div class="row page-heading">
      		<div class="col-7 input module_heading" role="heading" aria-level="1">
        		<span class="module_icon ic-inst"></span>
        		<label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}} {{institution.orgType}}</label>
        		<!-- <label class="head_txt module_type_name institution-title ace_sec_hd"><span v-if="advisorTitle">{{advisorTitle}}: </span>{{institution.title}}</label>
        		<label class="head_txt module_type_name ace_sec_hd" v-if="showEntity"> <span class="separator">::</span> {{entity.title}}</label> -->
      		</div>
      		<div class="col-5 btn_container">
            <b-btn v-if="isSuperAdmin" @click="administerPackagesClicked">edit</b-btn>
      		</div>
    	</div>

    	<div class="page_content_container">

      		<institution-menu :uuid="uuid" :active="'packages'"></institution-menu>

			<div class="row pg_content">
	      		<div class="col-12">
	        		<div class="row pkg_bx_container">

	          			<template v-for="(packageObject, index) in formattedPackages">
		            		<div class="col-xl-4 col-lg-6 col-md-12 col-sm-12">
			            		<div class="pkg_entity_bx">
			            			<div class="bx_inner">
			            				<div class="thumbnail_container">
				              				<!-- <span id="packageLogo"></span> -->
				              				<div class="ic icon-explore" v-if="packageObject.title === 'Explore'"></div>
				              				<div class="ic icon-course" v-if="packageObject.title === 'Course Planning'"></div>
				              				<div class="ic ico-ExternalCourse" v-if="packageObject.title === 'External Courses'"></div>
				              				<div class="ic icon-meter" v-if="packageObject.title === 'Dashboard'"></div>
				              				<div class="ic ico-miscellanous" v-if="packageObject.title === 'Misc'"></div>
				              			</div>
				              			<div class="entity_title">
				              				<span id="packageTitle" class="entity_title_txt">{{packageObject.title}}</span>
				              				<span :id="'packageInfo_' + index" class="exclamation-circle"><span class="ico-error"></span></span>
				              			</div>
				              			<div class="btm_row">
				              				<switches v-model="packageObject.enabled" text-enabled="Yes" text-disabled="No"></switches>
				              				<span
																v-if="isPackageEnabled(packageObject)"
																@click="editPackage(packageObject)"
																class="ic_btn ic_pencil"
																tabindex="0"
																:aria-label="$t('editPackageAria')"
																:title="$t('editPackageTitle')"
																v-b-tooltip.hover>
															</span>
				              			</div>
				              			<b-popover :target="'packageInfo_' + index" triggers="hover" :title="packageObject.description"></b-popover>
			              			</div>
			            		</div>
		            		</div>
	          			</template>

	        		</div>
	      		</div>
      		</div>

    	</div>

	</div>
</template>

<script>
import '../../../assets/module/sass/institution/institutionPackage.scss'
import { mapState, mapActions } from 'vuex'
import InstitutionMenu from './InstitutionMenu'
import InstitutionHeader from './InstitutionHeader'
import _ from 'lodash'
import '../../../assets/module/css/user/userList.min.css'

export default {
  name: 'institutionPackages',
  props: ['uuid'],
  components: {
    InstitutionMenu,
    InstitutionHeader
  },
  data: () => {
    return {
      userObject: JSON.parse(localStorage.getItem('userobj')),
      userRole: localStorage.getItem('userrole'),
      superAdminPermissionName: 'SUPERADMIN_PERMISSION'
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    ...mapActions([
      'loadInstitutionDetail',
      'loadPackages',
      'loadInstitutionPackage',
      'loadUserAdvisor',
      'loadLogDashboardActivity'
    ]),
    loadData () {
      if (this.isSuperAdmin) {
        this.loadPackages()
      }
      this.loadInstitutionDetail(this.uuid)
      this.loadInstitutionPackage({uuid: this.uuid, isAggregated: false})
    },
    editPackage (packageObject) {
      return this.$router.push({ name: 'editInstitutionPackage', params: { uuid: this.uuid, packageId: packageObject.packageId } })
    },
    isPackageEnabled (packageObject) {
      if (!this.isSuperAdmin) {
        return true // only enabled packages appear for other roles
      }
      let isEnabled = false
      let targetId = packageObject.packageId
      let institutionPackages = this.packages
      institutionPackages.forEach(currentPackage => {
        if (targetId === currentPackage.packageId) {
          isEnabled = true
        }
      })
      return isEnabled
    },
    administerPackagesClicked () {
      return this.$router.push({ name: 'administerInstitutionPackages', params: { uuid: this.uuid } })
    }
  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution,
      'allPragyaPackages': state => state.institution.allPragyaPackages,
      'packages': state => state.institution.packages,
      'permission': state => state.user.permission,
      'enabledFeatures': state => state.institution.enabledFeatures
    }),
    formattedPackages () {
      let formattedPackages = []
      let institutionPackages = this.packages
      let packages = this.isSuperAdmin ? this.allPragyaPackages : institutionPackages
      if (!packages || packages.length <= 0) {
        return []
      }
      let isEnabled = this.isPackageEnabled
      packages.forEach(packageObject => {
        // clone the state variables to prevent vuex violation from array mutation
        let clonedPackage = _.cloneDeep(packageObject)
        clonedPackage.enabled = isEnabled(packageObject)
        formattedPackages.push(clonedPackage)
      })
      return formattedPackages
    },
    isSuperAdmin () {
      let userObject = this.userObject
      let permission = userObject.permission || this.permission
      return permission.name === this.superAdminPermissionName
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionPackages.vue